import type { DocumentsTableItem } from "../Stores/DocumentsTableStore";

type DocumentsItemLike = Pick<DocumentsTableItem, "id" | "type">;

/**
 * Folder ids and file ids come from separate backend sequences, so the same numeric id can
 * belong to both a folder and a file inside one directory listing. Every lookup that resolves
 * a file id against the flattened table data must therefore exclude folders explicitly.
 */
export const isFolderItem = (item: Pick<DocumentsTableItem, "type">): boolean => Boolean(item?.type?.startsWith("FO"));

export const isFileItem = (item: Pick<DocumentsTableItem, "type">): boolean => Boolean(!item?.type?.startsWith("FO"));

export const findFileById = <T extends DocumentsItemLike>(items: T[], id: number): T | undefined =>
  items?.find((item) => item?.id === id && !isFolderItem(item));

/** Folder `296295` → `F296295`; file `296295` → `296295`. */
export const getDocumentsRowKey = (item: DocumentsItemLike): string =>
  isFolderItem(item) ? `F${item.id}` : String(item.id);

export const isFolderRowKey = (key: string): boolean => typeof key === "string" && key.startsWith("F");

export const isFileRowKey = (key: string): boolean => typeof key === "string" && !key.startsWith("F");

export const fileIdFromRowKey = (key: string): number | undefined => {
  if (!isFileRowKey(key)) {
    return undefined;
  }
  const id = Number(key);
  return Number.isFinite(id) ? id : undefined;
};
